import './counter-signatures.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import { CounterSignature as CounterSignatureType } from '@skinsoft/types';

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { ADD_COUNTER_SIGNATURE, COUNTER_SIGNATURE_UPDATED, REMOVE_COUNTER_SIGNATURE } from '../../../../busTopics';
import { CounterSignature } from './counter-signature';

@Component({
    components: {
        sCounterSignature: CounterSignature,
    },
    props: {
        counterSignatures: {
            type: Array as PropType<CounterSignatureType[]>
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: ''
        },
    },
    template: require('./counter-signatures.html')
})
export class CounterSignatures extends ReactiveVue {
    private counterSignatures: CounterSignatureType[]

    private plusIcon = faPlusCircle

    private COUNTER_SIGNATURE_UPDATED = COUNTER_SIGNATURE_UPDATED
    private REMOVE_COUNTER_SIGNATURE = REMOVE_COUNTER_SIGNATURE

    private onSignatureUpdated(updatedSigner: CounterSignatureType, index: number) {
        this.$emit(COUNTER_SIGNATURE_UPDATED, [updatedSigner, index])
    }

    private onDeleteSignature(index: number) {
        this.$emit(REMOVE_COUNTER_SIGNATURE, index)
    }

    private addSigner() {
        this.$emit(ADD_COUNTER_SIGNATURE)
    }
}